export default __webpack_public_path__ + "static/media/Blues.ae9c0a72.svg";